export default function (context, val) {
    context.commit('set_form', {
        CategoryId: val,
    });
    if (!context.rootGetters['dictionary/paymentType/list']) return;
    if (context.rootGetters['dictionary/paymentType/getById'](context.state.form.PaymentTypeId).CategoryId !== val) {
        context.dispatch('change_PaymentTypeId', context.rootGetters['dictionary/paymentType/list'](val)[0].value);
    }
    switch (val) {
        case 0:
            context.commit('set_form', {
                CashId: context.rootState.dictionary.cash.list[0].value,
            });
            break;
        case 1:
            context.commit('set_form', {
                PaymentAccountId: context.rootState.dictionary.paymentAccount.list[0].value,
            });
            break;
    }
}